module.exports = __webpack_public_path__ + "img/call.bf793721.jpg";